declare global {
  interface Window {
    onGoogleMapsLoaded: () => void;
    google?: typeof google;
  }
}

const pendingRequests: {
  maps?: Promise<void>;
} = {};

const isGoogleMapsReady = () => typeof window.google !== 'undefined' && Boolean(window.google.maps);

const loadGoogleMaps = () => {
  if (isGoogleMapsReady()) {
    return Promise.resolve();
  }

  const existing = document.getElementById('gMaps');

  if (existing) {
    return new Promise<void>((resolve) => {
      const previous = window.onGoogleMapsLoaded;

      window.onGoogleMapsLoaded = () => {
        previous?.();
        resolve();
      };
    });
  }

  const key = window.env.GOOGLE_API_KEY;
  const apiBase = 'https://maps.googleapis.com/maps/api/js';
  const script = document.createElement('script');

  script.setAttribute('id', 'gMaps');
  script.setAttribute('async', '');
  script.src = `${apiBase}?key=${key}&language=en&libraries=places,visualization&callback=onGoogleMapsLoaded`;
  document.head.appendChild(script);

  return new Promise<void>((resolve) => {
    window.onGoogleMapsLoaded = resolve;
  });
};

const ensureVisualizationLibrary = async () => {
  if (window.google?.maps?.visualization?.HeatmapLayer) {
    return;
  }

  const mapsWithImport = window.google?.maps as
    | (typeof google.maps & { importLibrary?: (name: string) => Promise<unknown> })
    | undefined;

  if (mapsWithImport?.importLibrary) {
    await mapsWithImport.importLibrary('visualization');
  }
};

export const ensureGoogleMaps = async () => {
  if (!pendingRequests.maps) {
    pendingRequests.maps = loadGoogleMaps();
  }

  await pendingRequests.maps;

  try {
    await ensureVisualizationLibrary();
  } catch (error) {
    console.error('Failed to load Google Maps visualization library:', error);
  }
};
